import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"DM_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-dm-sans\",\"display\":\"swap\"}],\"variableName\":\"dmSans\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Playfair_Display\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"700\"],\"variable\":\"--font-playfair\",\"display\":\"swap\"}],\"variableName\":\"playfair\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/frontend/src/components/layout/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageTransition"] */ "/vercel/path0/frontend/src/components/layout/PageTransition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TimedPopup"] */ "/vercel/path0/frontend/src/components/layout/TimedPopup.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/styles/globals.scss");
